import Text from '../../../common/Text/Text';

const Typography = () => {
  return (
    <div>
      <table>
        <thead>
          <tr>
            <th>STYLE</th>
            <th>WEIGHT</th>
            <th>POINT SIZE</th>
            <th>LINE HEIGHT</th>
            <th>LETTER SPACING</th>
            <th>USE</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Text type="header">Header</Text>
            </td>
            <td>
              <Text type="body">Bold</Text>
            </td>
            <td>
              <Text type="body">24pt</Text>
            </td>
            <td>
              <Text type="body">30pt</Text>
            </td>
            <td>
              <Text type="body">0</Text>
            </td>
            <td className="usecase">Headlines | Primary addresses</td>
          </tr>
          <tr>
            <td>
              <Text type="subheader">Subheader</Text>
            </td>
            <td>
              <Text type="body">Regular</Text>
            </td>
            <td>
              <Text type="body">16pt</Text>
            </td>
            <td>
              <Text type="body">20pt</Text>
            </td>
            <td>
              <Text type="body">0</Text>
            </td>
            <td className="usecase">Headlines secondary</td>
          </tr>
          <tr>
            <td>
              <Text type="body">Body</Text>
            </td>
            <td>
              <Text type="body">Regular</Text>
            </td>
            <td>
              <Text type="body">14pt</Text>
            </td>
            <td>
              <Text type="body">18pt</Text>
            </td>
            <td>
              <Text type="body">0</Text>
            </td>
            <td className="usecase">Contents details copy </td>
          </tr>
          <tr>
            <td>
              <Text type="callout">Callout</Text>
            </td>
            <td>
              <Text type="body">Bold</Text>
            </td>
            <td>
              <Text type="body">14pt</Text>
            </td>
            <td>
              <Text type="body">18pt</Text>
            </td>
            <td>
              <Text type="body">0</Text>
            </td>
            <td className="usecase">Buttons</td>
          </tr>
          <tr>
            <td>
              <Text type="body" size="small">
                Body Small
              </Text>
            </td>
            <td>
              <Text type="body">Regular</Text>
            </td>
            <td>
              <Text type="body">12pt</Text>
            </td>
            <td>
              <Text type="body">16pt</Text>
            </td>
            <td>
              <Text type="body">0</Text>
            </td>
            <td className="usecase">Label</td>
          </tr>
          <tr>
            <td>
              <Text type="callout" size="small">
                Body Small Callout
              </Text>
            </td>
            <td>
              <Text type="body">Bold</Text>
            </td>
            <td>
              <Text type="body">12pt</Text>
            </td>
            <td>
              <Text type="body">16pt</Text>
            </td>
            <td>
              <Text type="body">0</Text>
            </td>
            <td className="usecase">Label</td>
          </tr>
          <tr>
            <td>
              <Text type="header" size="small">
                Header Small
              </Text>
            </td>
            <td>
              <Text type="body">Bold</Text>
            </td>
            <td>
              <Text type="body">12pt</Text>
            </td>
            <td>
              <Text type="body">16pt</Text>
            </td>
            <td>
              <Text type="body">5%</Text>
            </td>
            <td className="usecase">Table column headers</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Typography;
